/**
 * pulls and returns a random element from the supplied elements
 *
 * @param elements
 */
export function randomElement<T = unknown>(elements: T[] | undefined) {
  if (!elements) return undefined
  if (!elements.length) return undefined
  const i = Math.floor(Math.random() * elements.length)
  return elements[i]
}
